import './loading-screen.css';

export default function LoadingScreen() {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
            <p>Even geduld...</p>
        </div>
    );
}
